import Joi from 'joi'
import { AppointmentType, Country, TeamAccess } from '../../../../constants'
import { ResourcePair } from '../../../../types'

interface ReservationFormData {
  appointmentType: AppointmentType
  clientStartDate?: Date
  country: Country
  dateStart: Date
  dateStartSelected?: Date
  durationInMinutes: number
  eligibleResourcePairs?: ResourcePair[]
  isCombinedBooking?: boolean
  leadGid: string
  leadSalesforceId: string
  recommendationId: string
  resourceIds: string[]
  state?: string
  timezone: string
  teamAccess?: TeamAccess
}

const defaultUSReservationFormValues: ReservationFormData = {
  appointmentType: AppointmentType.HEARING_AID_EVALUATION,
  country: Country.US,
  dateStart: new Date(),
  durationInMinutes: 60,
  leadGid: '',
  leadSalesforceId: '',
  recommendationId: '',
  resourceIds: [],
  state: '',
  timezone: 'America/Denver',
}

const defaultDEReservationFormValues: ReservationFormData = {
  appointmentType: AppointmentType.HEARING_AID_EVALUATION,
  country: Country.DE,
  dateStart: new Date(),
  durationInMinutes: 60,
  leadGid: '',
  leadSalesforceId: '',
  recommendationId: '',
  resourceIds: [],
  timezone: 'Europe/Berlin',
  teamAccess: TeamAccess.MY_TEAM,
}

const getDefaultReservationFormValues = (country: Country) =>
  country === Country.DE ? defaultDEReservationFormValues : defaultUSReservationFormValues

const appointmentType = Joi.string()
  .uppercase()
  .valid(...Object.values(AppointmentType))
  .optional()

const baseReservationSchema = {
  appointmentType,
  clientStartDate: Joi.date().optional(),
  country: Joi.string().required(),
  dateStart: Joi.date().optional(),
  dateStartSelected: Joi.date().optional(),
  durationInMinutes: Joi.number().optional(),
  eligibleResourcePairs: Joi.array().items(Joi.array().items(Joi.string()).min(1).max(2)).optional(),
  isCombinedBooking: Joi.boolean().optional(),
  leadGid: Joi.string().required(),
  leadSalesforceId: Joi.string().required(),
  recommendationId: Joi.string().required(),
  resourceIds: Joi.array().items(Joi.string()).optional(),
  timezone: Joi.string().optional(),
  teamAccess: Joi.string()
    .valid(...Object.values(TeamAccess))
    .optional(),
}

export const reservationFormUSValidationSchema = Joi.object<ReservationFormData>({
  ...baseReservationSchema,
  state: Joi.string().required(),
}).required()

export const reservationFormDEValidationSchema = Joi.object<ReservationFormData>(baseReservationSchema).required()

const getReservationFormValidationSchema = (country: Country) =>
  country === Country.DE ? reservationFormDEValidationSchema : reservationFormUSValidationSchema

export { getDefaultReservationFormValues, getReservationFormValidationSchema }
export type { ReservationFormData }
